export interface Outcome {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: '⚡ Smetti di Imparare in Modo Casuale',
    description:
      'Segui un percorso progressivo invece di passare continuamente tra tutorial, forum, video e informazioni scollegate.',
  },
  {
    title: '🏠 Passa dalla Teoria alla Pratica',
    description:
      'Utilizza procedure, esempi, progetti, checklist e applicazioni concrete per capire come costruire realmente un sistema Smart Home.',
  },
  {
    title: '🔗 Crea Sistemi Più Coerenti',
    description:
      'Impara a ragionare su compatibilità, protocolli, dispositivi e integrazioni prima di acquistare e configurare tutto senza una strategia.',
  },
  {
    title: '🚀 Costruisci Competenze Passo Dopo Passo',
    description:
      'Parti dalle fondamenta, progetta, configura, automatizza e integra fino ad arrivare a progetti Smart Home completi.',
  },
]
